<script>
import { mapState } from 'vuex';
export default{
    name: 'UploadCsv',
    data(){
        return {
            list: [],
            counter: 0,
            productIds: [],
            keywords: [],
            pincodes: [],
            uploadedFile: null,
            validationErrorMessage: "Selected File Format is Incorrect !",
            validationSuccessMessage: "File Selected Successfully !"
        }
    },
    props: {
        uploadCsvType: String,
        loadingForUpload: Boolean
    },
    computed: {
        ...mapState(['campaignClass']),
        canUpload() {
            return ((this.productIds.length || this.keywords.length || this.pincodes.length) && this.uploadedFile );
        }
    },
    methods: {
        isValidEmail(email) {
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return emailPattern.test(email);
        },
        filterValidEmails(emailArray) {
            return emailArray.filter(email => this.isValidEmail(email));
        },
        deleteFromList(index) {
            this.list.splice(index, 1);
        },
        addItem() {
            this.list.push(this.counter++);
        },
        handleFileUpload(event) {
            this.uploadedFile = this.$refs.csvFileInput.files[0];
            this.$emit('onFileUpload');
            let reader = new FileReader();
            reader.readAsText(this.uploadedFile);
            reader.onload = event => {
                let csvData = event.target.result;
                this.parseCSV(csvData);
            };
        },
        removeUploadedFile() {
            this.uploadedFile = null;
            this.productIds = [];
            this.keywords = [];
            this.pincodes = [];
            this.$refs.csvFileInput.value = '';
        },
        parseCSV(csvData){
            if(this.uploadCsvType === 'pincodes') {
                const valuesArray = csvData.split("\n");
                const pincodeSet = new Set();
                const pincodeList = [];
                for (let i = 0; i < valuesArray.length; i++) {
                    const line = valuesArray[i].split(',');
                    const pincode = line[0];
                    const district = line[1];
                    const state = line[2];
                    if(i === 0) {
                        if(pincode != 'Pincode' || district.trim() != 'District' || state.trim() != 'State') return this.pincodes = [];
                    }
                    if(/^[0-9]{6}$/.test(pincode.trim()) && /^[A-Za-z ]+$/.test(district.trim()) && /^[A-Za-z ]+$/.test(state.trim())) {
                        if (!pincodeSet.has(pincode)) {
                            pincodeSet.add(pincode);
                            pincodeList.push({
                                pincode: Number(pincode),
                                district,
                                state,
                            })
                        }
                    }
                }
                this.pincodes = pincodeList;
            }
            else if (this.uploadCsvType === 'keywords') {
                const valuesArray = csvData.split("\n");
                const keywordSet = new Set();
                const keywordArray = [];

                for (let i = 0; i < valuesArray.length; i++) {
                const line = valuesArray[i].split(',');
                const keyword = this.campaignClass === 'Privilege' ? line[0].trim() : line[0];
                if(i === 0) {
                    if(keyword != 'Keyword' || (this.campaignClass !== 'Privilege' && line[1].trim() != 'Bid')) return this.keywords = [];
                }
                let bidPrice = this.campaignClass !== 'Privilege' ? parseFloat(line[1]?.trim()).toFixed(2) : 1; // added 1 for privilege but takes cpd from campaign
                if(/^[a-zA-Z0-9\s-]+$/.test(keyword) && bidPrice > 0){
                    if (!keywordSet.has(keyword)) {
                        keywordSet.add(keyword);
                        const obj = {
                            "keyword": keyword,
                            "bid_price": parseFloat(bidPrice)
                        };
    
                        keywordArray.push(obj);
                    }
                }
                }
                this.keywords = keywordArray;
            } else {
                const lines = csvData.split('\n');
                const values = lines.map(line => line.split(','));
                const flattenedValues = values.flat().filter(value => value.trim() !== '').map(item => item.replace('\r', ''));
                let productIDArray = [csvData][0].split(',').map(value => value.replace(/['"]/g, '').trim());

                if(this.uploadCsvType !== 'emails'){
                    if(!/^[0-9]+$/.test(flattenedValues[0])) return this.productIds = [];
                    this.productIds= flattenedValues;
                    this.$emit('productIDArray', flattenedValues);
                }else if(this.uploadCsvType === 'emails'){
                    let validEmails = this.filterValidEmails(flattenedValues).map(email => email.toLowerCase());
                    const uniqueEmailsSet = new Set(validEmails);
                    validEmails = Array.from(uniqueEmailsSet); 
                    this.$emit('emailIDArray', validEmails)
                }
            }
        },
        onUploadClick(){
            this.$emit('updateLoader', true);
            if(this.productIds.length || this.uploadCsvType === 'emails'){
                this.$emit('uploadBtnclicked')
            }else if(this.uploadCsvType === 'keywords') {
                this.$emit('keywordArray', this.keywords);
            } else if(this.uploadCsvType === 'pincodes') {
                this.$emit('pincodeList', this.pincodes);
            }
        },
    }
}
</script>

<template>
        <div class="container"> 
            <a
                class="sampleCsv"
                :href="`/files/sample-${this.uploadCsvType}${this.uploadCsvType === 'keywords' && this.campaignClass === 'Privilege' ? '-cpd' : ''}.csv`"
                download
            >
                <div class="wrap"> 
                    <img class="csvIcon" src="../assets/sampleCsv.svg">
                    <div> 
                        <div class="text">Sample CSV</div>
                        <div class="date">June 8, 2022 09:50:05 AM</div>
                    </div>
                </div>
                <img  src="../assets/downloadIcon.svg">
            </a>
            <div class="table">
                <div class="content"> 
                    <img class="uploadIcon" src="../assets/uploadIcon.svg"> 
                    <div class="title">Drag and drop csv here</div>
                    <div class="title">OR</div>

                    <div class="inputWrapper">
                        <input accept=".csv" ref="csvFileInput" :class="{'noFile': !uploadedFile}" v-on:change="handleFileUpload" type="file" />
                        <button v-if="uploadedFile" class="removeBtn" @click="removeUploadedFile">
                            <img class="deleteIcon" src="../assets/trashIcon.svg" v-b-tooltip title="Remove">
                        </button>
                    </div>

                    
                    <div v-if="uploadedFile" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                        <div v-if="!canUpload" class="errorHeading" >
                            <img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}
                        </div>
                        <div v-else-if="canUpload" class="successHeading" >
                            <img src="../assets/successIcon.svg" style="width: 20px; height: 20px; margin-right: 14px" /> {{ this.validationSuccessMessage }}
                        </div>
                    </div>
                    

                    <button v-if="!loadingForUpload" :disabled="!canUpload" class="uploadTxt" @click="onUploadClick">Upload</button>
                    <div v-else class="loaderWrapper"> 
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
</template>

<style scoped>

    .wrap{
        display: flex;
    }

    .title{
        margin: 10px auto;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #666666;
    }

    .content{
        height: 100%;
    }

    .uploadTxt{
        background: #2E31BE;
        border-radius: 4px;
        border: 0;
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #FFFFFF;
        width: 80px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 15px auto;
    }
    .uploadTxt:disabled {
        opacity: 0.3;
    }

    .sampleCsv{
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        padding: 5px 20px;
        margin: 5px 15px;
    }

    .text{
        font-weight: 600;
        font-size: 10.8363px;
        line-height: 16px;
        color: #41434C;
    }

    .date{
        font-weight: 400;
        font-size: 6.59077px;
        line-height: 150%;
        color: #9B9B9B;
    }

    .uploadIcon{
        width: 44px;
        height: 44px;
        margin-top: 58px;
    }

    .csvIcon{
        margin-right: 15px;
    }

    .deleteIcon {
        color: #EB5757;
    }

    input.noFile {
        margin-left: 30%;
    }
    .text{
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        color: #333333;
    }


    .table{
        cursor: pointer;
        max-width: 530px;
        min-height: 320px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #F5F8FF;
    }

    .loaderWrapper{
        margin: 15px auto;
    }

    .loader {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 3px solid #ccc;
        border-top: 3px solid #007BFF;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    .inputWrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
    }
    .removeBtn {
        background: transparent;
        color: #EB5757;
        border: none;
        font-size: 12px;
        cursor: pointer;
        margin-left: 0px;
        text-decoration: underline;
    }
    
    .errorContainer{
        border-radius: 8px;
        margin: 1%;
        padding: 18px 24px 8px 24px;
    }

    .errorHeading{
        font-weight: 700;
        font-size: 14px;
        line-height: 140%;
        color: #EB5757;
        /* margin-bottom: 12px; */
        display: flex;
    }
    
    .successHeading {
        font-weight: 700;
        font-size: 14px;
        line-height: 140%;
        color: #105534;
        display: flex;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>